<template>
  <div>
    <el-form :rules="rules" ref="form" :model="form" class="login-box">
      <h3 class="title">欢迎登录</h3>
      <el-form-item label="账户" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import Global from "./Global";

  export default {
    name: 'login',
    data() {
      return {
        form: {
          name: '',
          password: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入账户名称', trigger: 'blur' },
            { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入账户密码', trigger: 'blur' },
            { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      submitForm(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.axios({
              method: 'post',
              url: Global.accountUrl + '/storkUser/checkAdmin',
              data: {
                password: that.form.password,
                username: that.form.name
              }
            })
            .then(function(response){
              if(response.data.code == 200) {
                sessionStorage.setItem('isLogin', 'true');
                that.$store.dispatch('asyncUpdateUser', {name: that.form.name});
                that.$router.push({'name': 'Home'});
              } else {
                that.$message.error('请输入正确的用户名和密码');
              }
            })
            .catch(function(error){
              that.$message.error('请输入正确的用户名和密码');
            })
          } else {
            this.$message.error('请输入正确的用户名和密码');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style scoped>
  .login-box {
    width: 350px;
    margin: 150px auto;
    border: 1px solid #DCDFE6;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .title {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue